import { render, staticRenderFns } from "./HEXT.vue?vue&type=template&id=b5c54f66&scoped=true&"
import script from "./HEXT.vue?vue&type=script&lang=js&"
export * from "./HEXT.vue?vue&type=script&lang=js&"
import style0 from "./HEXT.vue?vue&type=style&index=0&id=b5c54f66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c54f66",
  null
  
)

export default component.exports